// assets/theme/components/table/tableHead.js
import borders from "assets/theme/base/borders";
import pxToRem from "assets/theme/functions/pxToRem";

const { borderRadius } = borders;

const tableHead = {
  styleOverrides: {
    root: {
      // ¡No usar display: "block" aquí!
      display: "table-header-group",
      // Mejor NO poner padding al root; el padding va en TableCell del head
      padding: 0,
      borderRadius: `${borderRadius.xl} ${borderRadius.xl} 0 0`,
    },
  },
};

export default tableHead;
